import { SortDirection } from '@mui/material';
import theme from 'theme';
import { ModelsTableHeadColumn } from '../../ModelsTable/ModelsTable.types';

const createSortHandler = (onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void) => (property: string) => (event: React.MouseEvent<unknown>) => {
  onRequestSort(event, property);
};

const orderHandler = (sortArg: string, sortDefault: SortDirection, orderBy: string, order: SortDirection) => {
  if (orderBy === sortArg) {
    return order;
  }
  return sortDefault;
};

const isActive = (headCell: ModelsTableHeadColumn, orderBy: string) => orderBy === headCell.id;

const getSortIconStyle = (headCell: ModelsTableHeadColumn, orderBy: string) => ({
  icon: {
    width: '10%',
    ...(isActive(headCell, orderBy) && { color: `${theme.palette.primary.dark} !important`, opacity: 1 }),
    ...(!isActive(headCell, orderBy) && { opacity: 0.2 }),
  },
});

/**
 * Calculates table height accounting for zoom level
 * @param zoomLevel - The current zoom level (typically from useZoom hook)
 * @param offset - The offset in pixels to subtract from the viewport height (default: 200)
 * @returns A CSS height string (e.g., "800px" or "calc(100vh - 200px)")
 */
const calculateTableHeight = (zoomLevel: number, offset: number = 200): string => {
  if (globalThis.window) {
    const viewportHeight = globalThis.window.innerHeight;
    const adjustedHeight = viewportHeight / zoomLevel;
    return `${adjustedHeight - offset}px`;
  }
  return `calc(100vh - ${offset}px)`;
};

export {
  createSortHandler,
  orderHandler,
  isActive,
  getSortIconStyle,
  calculateTableHeight,
}